module.exports = __webpack_public_path__ + "static/media/p2_11.dd836333.png";